import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface EventTypeBadgeProps {
  kind: number;
  label: string;
  className?: string;
}

const accentBadgeClass = 'bg-accent/10 text-accent border-accent/20';

export function EventTypeBadge({ kind, label, className }: EventTypeBadgeProps) {
  const colorClass = accentBadgeClass;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn(
            'inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium border',
            colorClass,
            className
          )}>
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-[240px]">
          <p className="font-medium">{label}</p>
          <p className="text-xs text-muted-foreground font-mono">kind {kind}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
